
import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lns-select-columns',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule, TranslateModule],
  templateUrl: './select-columns.component.html',
  styleUrls: ['./select-columns.component.scss'],
})
export class SelectColumnsComponent implements OnInit {
  modalColumns: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectColumnsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit() {
    if (this.data && this.data.allColumns) {
      this.data.allColumns.forEach(element => {
        if (this.data.selectedColumns.indexOf(element) > -1) {
          this.modalColumns.push({
            field: element,
            text: `${this.data.translatePfx}.${element}`,
            value: true
          });
        } else {
          this.modalColumns.push({
            field: element,
            text: `${this.data.translatePfx}.${element}`,
            value: false
          });
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
